import {
  FeatureFlagContext,
  FeatureFlagType,
  IFeatureFlagCreatePayload,
  IFeatureFlagEditPayload,
} from "interfaces/feature-flags";

export type FeatureFlagPayloadFormValues = {
  name: string;
  key: string;
  enabled?: boolean;
  flag_type?: FeatureFlagType;
  contexts?: FeatureFlagContext;
  target_repos?: string | string[];
  tags?: string | string[];
};

const splitAndTrim = (value: string): string[] =>
  value
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item !== "");

export const normalizeFeatureFlagListInput = (
  value?: string | string[] | null,
): string[] => {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.reduce<string[]>((items, item) => {
      return items.concat(splitAndTrim(item));
    }, []);
  }

  return splitAndTrim(value);
};

export const buildFeatureFlagCreatePayload = (
  values: FeatureFlagPayloadFormValues,
): IFeatureFlagCreatePayload => ({
  name: values.name,
  key: values.key,
  enabled: values.enabled ?? false,
  flag_type: values.flag_type as FeatureFlagType,
  contexts: values.contexts as FeatureFlagContext,
  target_repos: normalizeFeatureFlagListInput(values.target_repos),
  tags: normalizeFeatureFlagListInput(values.tags),
  description: "",
});

export const buildFeatureFlagEditPayload = (
  values: FeatureFlagPayloadFormValues,
): IFeatureFlagEditPayload => ({
  name: values.name,
  key: values.key,
  enabled: values.enabled ?? false,
  flag_type: values.flag_type as FeatureFlagType,
  contexts: values.contexts as FeatureFlagContext,
  target_repos: normalizeFeatureFlagListInput(values.target_repos),
  tags: normalizeFeatureFlagListInput(values.tags),
});
